// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__U22yX","inner":"Form_inner__1lFF0","range":"Form_range__3wjm9","name":"Form_name__3IxG3","actions":"Form_actions__1tVco"};